<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de aplicação de campanha">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/aplicacao-campanha/List'

export default {
    components: { List },
}
</script>